import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { NextPage } from 'next';
import { Layout } from '../../../components/Layout';
import { OneTrustContent } from '../../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../../components/SEOData';

const WorkforceApplicantPrivacyPolicyPage: NextPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Workforce and Applicant Privacy Policy | Stitch Fix"
        canonicalUrl="https://www.stitchfix.com/careers/workforce-applicant-privacy-policy/"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="6cd261f7-7c44-43e6-bcec-29ca302f2177" />
      </ResponsiveSection>
    </Layout>
  );
};

export default WorkforceApplicantPrivacyPolicyPage;
